export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SmallSlider.vue?vue&type=template&id=210144ce&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SmallSlider.vue?vue&type=template&id=210144ce&scoped=true&
// module id = 163
// module chunks = 0